(function($) {
    'use strict';

    class SalaryCalculator {
        constructor() {
            this.apiService = new ApiService();
            this.form = new Form();
            this.fieldActivator = new FieldActivator(this.form);
            this.results = new Results(this.apiService);
            this.lastRequestData = null;
            
            this.bindEvents();
        }

        bindEvents() {
            this.form.$form.on('input change', 'input, select', () => {
                if (this.form.validateForm()) {
                    const formData = this.form.getFormData();
                    
                    if (JSON.stringify(formData) !== JSON.stringify(this.lastRequestData)) {
                        this.lastRequestData = formData;
                        
                        this.apiService.calculate(formData)
                            .then(response => {
                                if (response.success) {
                                    console.log(response);
                                    this.form.$form.addClass('calculated')
                                    this.results.show(response.data);
                                }else{
                                    this.form.$form.removeClass('calculated')
                                }
                            })
                            .catch(error => console.error('Calculation error:', error));
                    }
                }
            });

            this.form.$form.on('click', '.salary-calculator__show-resut-btn', (e) => {
                e.preventDefault();
                this.form.$getResultsPopup.addClass('active');
                $('.sc_get_calculation_results__btn').prop('disabled', true);
                
            });

            this.form.$getResultsPopup.on('click', (e) => {
                if ($(e.target).closest('.sc_get_calculation_results__form').length === 0) {
                    this.form.$getResultsPopup.removeClass('active');
                    $('.sc_get_calculation_results__success-message').fadeOut();
                    $('.sc_get_calculation_results__success-message').addClass('hidden');
                    $('.sc_get_calculation_results__btn').prop('disabled', false);
                    this.results.$emailInput.val('');
                }
            });

            this.form.$getResultsPopup.on('click', '.sc_get_calculation_results__close', () => {
                this.form.$getResultsPopup.removeClass('active');
                $('.sc_get_calculation_results__success-message').fadeOut();
                $('.sc_get_calculation_results__success-message').addClass('hidden');
                $('.sc_get_calculation_results__btn').prop('disabled', false);
                this.results.$emailInput.val('');
            });

            $('.sc_get_calculation_results__btn').on('click', () => {
                const email = this.results.$emailInput.val();
                const pdfData = this.results.$pdfData.val();
                const resultAmount = this.results.$amount.text();
                const bolagsform = this.form.bolagsform.val();
                const age = this.form.age.val();

                this.apiService.generatePDF({
                    pdfData: pdfData,
                    amount: resultAmount,
                    email: email,
                    bolagsform: bolagsform,
                    age: age
                })
                .then(response => {
                    if (response.success) {
                        // const link = document.createElement('a');
                        // link.href = 'data:application/pdf;base64,' + response.data.pdf;
                        // link.download = response.data.filename;
                        // link.click();
                        
                        $('.sc_get_calculation_results__success-message').fadeIn();
                        $('.sc_get_calculation_results__success-message').removeClass('hidden');
                        
                        this.results.$emailInput.val('');
                        
                        $('.sc_get_calculation_results__btn').prop('disabled', true);
                    } else {
                        console.error('PDF generation failed:', response.data.message); 
                    }
                })
                .catch(error => console.error('PDF generation error:', error));
            });
        }
    }

    $(document).ready(() => {
        window.salaryCalculator = new SalaryCalculator();
    });

})(jQuery); 